import { call, put, takeEvery, select } from 'redux-saga/effects'

import { isWaiting } from '../selectors'
import { offline } from '../actions'
import { makeRequest } from './makeRequest'

export function* addToQueue({ payload: { actionType, params } }) {
  const action = { type: actionType, payload: { ...params } }
  // execute an action in order to add the data to local redux store
  yield put(action)
  const waiting = yield select(isWaiting)
  if (waiting) {
    yield put(offline.addToWaiting(action))
    return { isWaiting: true }
  } else {
    yield put(offline.startWaiting(action))
    const response = yield call(makeRequest, action)
    yield put(offline.shiftFirst())
    return response
  }
}

export default function* addToQueueEvery() {
  yield takeEvery(offline.request.toString(), addToQueue)
}
